const theme = {
  token: {
    // Seed Token
    colorPrimary: "#031D44",
    colorSecondary: "#01A5E4",
    borderRadius: 2,
  },
};

export default theme;
